// RECENT PRODUCTS UTILS
const RECENT_KEY = "recent_product_ids";
const MAX_RECENTS = 20;

export function getRecentProductIds() {
  if (typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function pushRecentProductId(id) {
  if (!id || typeof window === "undefined") return;
  const ids = getRecentProductIds();
  const filtered = ids.filter((x) => x !== id);
  filtered.unshift(id);
  const capped = filtered.slice(0, MAX_RECENTS);
  localStorage.setItem(RECENT_KEY, JSON.stringify(capped));
}

export function clearRecentProducts() {
  if (typeof window === "undefined") return;
  localStorage.removeItem(RECENT_KEY);
}
